module.exports = __webpack_public_path__ + "static/media/alejandroC.727e592f.jpg";